// extracted by mini-css-extract-plugin
module.exports = {"item":"EmployeeDetailSection_item_2_LtF","title":"EmployeeDetailSection_title_WIHEh","hint":"EmployeeDetailSection_hint_1bSA2"};